@if (!online()) {
<div
    @slideDown
    class="pwa-offline-indicator fixed inset-x-0 top-0 z-9999 flex items-center justify-center gap-2 bg-solewa-black px-4 py-1.5 pt-[calc(0.375rem_+_env(safe-area-inset-top,_0px))] text-center text-sm font-medium text-solewa-white print:hidden"
    role="status"
    aria-live="polite"
>
    <mat-icon
        class="icon-size-4 text-solewa-white"
        [svgIcon]="'heroicons_outline:signal-slash'"
    ></mat-icon>
    <span>Hors ligne — affichage des dernières données reçues</span>
</div>
}
